// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Tooltip-cls1___8014d7077239131e517{/*!*/}.Tooltip-cls2___21fb55c0272dfd7be24{width:0;height:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Tooltip-cls1___8014d7077239131e517",
	"cls2": "Tooltip-cls2___21fb55c0272dfd7be24 Tooltip-cls1___8014d7077239131e517"
};
export default ___CSS_LOADER_EXPORT___;
